import { createFileRoute } from '@tanstack/react-router';

import { requireAuth } from '@/app/lib/auth-guard';
import { AuthorizedUsersPage } from '@/settings/pages/authorized-users';

export const Route = createFileRoute('/settings/authorized-users/')({
  beforeLoad: async (ctx) => {
    await requireAuth(ctx);
  },
  component: AuthorizedUsersRoute,
  staticData: {
    headerSection: null
  }
});

function AuthorizedUsersRoute() {
  return <AuthorizedUsersPage/>;
}
